import { useHostedPageUrls } from "@propelauth/react";
import EmbedExternalPage from "../shared/embed-external-page";

export default function UserManagement() {
  const urls = useHostedPageUrls();
  const userManagementUrl = urls.getOrgPageUrl();

  return <EmbedExternalPage url={userManagementUrl} />;
}
